export default __webpack_public_path__ + "static/media/erik.cb60d1fb.jpg";